/* eslint-disable local-rules/no-nested-component */
/* eslint-disable react/no-danger,no-underscore-dangle */

/**
 * All of this magic helps us to get server side rendering of material-ui styles
 * working with Next.js
 *
 * Based on:
 * https://github.com/adrianmcli/styled-mui-next/tree/master
 * https://github.com/mui-org/material-ui/tree/master/examples/nextjs
 */

import { SheetsRegistry } from 'jss';
import { createTheme } from '@mui/material/styles';
import createGenerateClassName from '@mui/styles/createGenerateClassName';
import React from 'react';
import JssProvider from 'react-jss/lib/JssProvider';
import flush from 'styled-jsx/server';

import { fonts } from '@custom-components/css';

export const STYLE_ELEMENT_ID = 'material-server-side';

const createMaterialContext = () => ({
  theme: createTheme({
    typography: {
      fontFamily: fonts.fontRegular
    }
  }),
  sheetsManager: new Map(),
  sheetsRegistry: new SheetsRegistry(),
  generateClassName: createGenerateClassName()
});

export const getMaterialContext = () => {
  if (!process.browser) {
    return createMaterialContext();
  }

  if (!global.__INIT_MATERIAL_UI__) {
    global.__INIT_MATERIAL_UI__ = createMaterialContext();
  }

  return global.__INIT_MATERIAL_UI__;
};

export const getMaterialStyleElement = (materialContext) => (
  <>
    {/**
     * Currently, the materialContext.sheetsRegistry shows an empty array, and there is no .add() method to add any styles.
     * Once we confirm that we won't use this in the future, we can remove it.
     *
     * Additionally, we may not use this sheetsRegistry properly
     * Reference: https://github.com/mui/material-ui/issues/9097#issuecomment-364947401
     */}
    <style
      id={STYLE_ELEMENT_ID}
      dangerouslySetInnerHTML={{
        __html: materialContext.sheetsRegistry.toString()
      }}
    />
    {flush() || null}
  </>
);

export const withMaterialSSR = (App, materialContext, props) => (
  <JssProvider registry={materialContext.sheetsRegistry} generateClassName={materialContext.generateClassName}>
    <App {...props} />
  </JssProvider>
);
